import { styled } from "@mui/material";

export const Container = styled("div")`
    padding: 30px;
`;

export const StyledImage = styled("img")`
    display: flex;
    width: 80%;
`;

export const ImageContainer = styled("div")`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const ButtonContainer = styled("div")`
    display: flex;
    width: 100%;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
`;
